import anime from 'animejs/lib/anime.es.js';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; 
import 'tippy.js/animations/shift-toward.css';

function inViewport( elements, callback ) {
  // Initialize observer
  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach( entry => {
      // Check if the element is intersecting
      if(entry.isIntersecting)
      {
        // If so, start the callback
        callback( entry );
      }
    });
  }, {threshold: .1});
  // Add elements to the observer
  elements.forEach( el =>  observer.observe(el) );
}

function contentAnimations() {

  /*
     * Gutenberg block: Group
     */
  document.querySelectorAll('.wp-block-group').forEach((item, i) => {

    inViewport( [item], ( entry ) => {

        if ( entry.target.classList.contains('revealed-children') ) return;

        anime({
            targets: entry.target.children,
            opacity: [0, 1],
            translateY: [50, 0],
            duration: 250,
            delay: anime.stagger(150, {start: 250}),
            easing: 'easeOutQuad'
        });

        entry.target.classList.add('revealed-children');

    });

  });

  /*
   * Gutenberg block: Columns
   */
  document.querySelectorAll('.wp-block-columns').forEach((item, i) => {

    inViewport( [item], ( entry ) => {

        if ( entry.target.classList.contains('revealed-children') ) return;

        anime({
            targets: entry.target.children,
            opacity: [0, 1],
            translateY: [50, 0],
            duration: 250,
            delay: anime.stagger(150, {start: 250}),
            easing: 'easeOutQuad'
        });

        entry.target.classList.add('revealed-children');

    });

  });

  /*
   * Gutenberg block: Column
   */
  document.querySelectorAll('.wp-block-column').forEach((item, i) => {

    inViewport( [item], ( entry ) => {

        if ( entry.target.classList.contains('revealed-children') ) return;

        anime({
            targets: entry.target.children,
            opacity: [0, 1],
            translateY: [50, 0],
            duration: 250,
            delay: anime.stagger(150, {start: 250}),
            easing: 'easeOutQuad'
        });

        entry.target.classList.add('revealed-children');

    });

  });

  /*
   * Gutenberg block: Media & Text
   */
  document.querySelectorAll('.wp-block-media-text').forEach((item, i) => {

    inViewport( [item], ( entry ) => {

        if ( entry.target.classList.contains('revealed-media-text') ) return;

        var flipped = entry.target.classList.contains('has-media-on-the-right');

        anime({
            targets: entry.target.querySelector('.wp-block-media-text__content'),
            opacity: [0, 1],
            translateX: flipped ? [-100, 0] : [100, 0],
            duration: 500,
            delay: 750,
            easing: 'easeOutQuad'
        });
        anime({
            targets: entry.target.querySelector('.wp-block-media-text__media'),
            opacity: [0, 1],
            translateX: flipped ? [100, 0] : [-100, 0],
            duration: 500,
            delay: 750,
            easing: 'easeOutQuad'
        });

        entry.target.classList.add('revealed-media-text');

    });

  });

    /*
   * Gutenberg block: List
   */
    document.querySelectorAll('.entry-content ul:not([class]), ul.is-style-circles').forEach((item, i) => {

      inViewport( [item], ( entry ) => {
  
          if ( entry.target.classList.contains('revealed-list-items') ) return;
  
          anime({
              targets: entry.target.children,
              opacity: [0, 1],
              translateX: [-25, 0],
              duration: 250,
              delay: anime.stagger(150, {start: 500}),
              easing: 'easeOutQuad'
          });
  
          entry.target.classList.add('revealed-list-items');
  
      });
  
    });


  /*
   * Gutenberg block: Animated Background
   */

  // Vertical wave
  document.querySelectorAll('.wp-block-sowmedia-animated-background.is-type-vertical-wave:not(.animation-disabled)').forEach((item, i) => {
      anime({
        targets: item.querySelector('path'),
        d: [
          { value: [
            'M66,0 L619,0 L619,813 C566.938735,708.924896 495.779666,641.831434 405.522793,611.719614 C270.137482,566.551885 122.294836,707.214027 36.8420555,558.059542 C-20.1264652,458.623218 -10.4071503,272.603371 66,0 Z',
            'M1.8189894e-12,0 L619,0 L619,813 C433.798971,788.152896 321.868179,725.385878 283.207624,624.698947 C225.216792,473.668551 456.734394,359.830567 380.0445,190.668116 C328.917905,77.8931487 202.236405,14.3371101 1.8189894e-12,0 Z']
          },
          { value: 'M66,0 L619,0 L619,813 C566.938735,708.924896 495.779666,641.831434 405.522793,611.719614 C270.137482,566.551885 122.294836,707.214027 36.8420555,558.059542 C-20.1264652,458.623218 -10.4071503,272.603371 66,0 Z' }
        ],
        easing: 'linear',
        duration: 30000,
        loop: true,
        autoplay: true
    });
  });

  // Blob
  document.querySelectorAll('.wp-block-sowmedia-animated-background.is-type-blob:not(.animation-disabled)').forEach((item, i) => {
    anime({
        targets: item.querySelector('path'),
        d: [
          { value: [
            'M364.087363,0.682469802 C643.492676,0.682469802 702.086068,60.0094098 702.086068,240.021774 C702.086068,420.034139 496.01463,551.447933 351.086068,601.943985 C206.157505,652.440037 0.0860675999,621.17021 0.0860675999,484.61282 C0.0860675999,348.05543 84.6820506,0.682469802 364.087363,0.682469802 Z',
            'M152,37 C277,-88 559.19291,140.447831 652,233.254921 C744.80709,326.062011 699.819117,454.604185 564.185948,537 C428.55278,619.395815 170.18888,677.526532 54.3427563,537 C-61.5033671,396.473468 27,162 152,37 Z',
            'M557.361304,145.687571 C679.615273,236.279109 751.020227,356.391803 657.902688,471.265138 C564.785149,586.138472 385.039921,689.692378 217.201182,565.322024 C49.362444,440.951671 -93.1005329,144.663227 77.5361931,41.2071731 C248.172919,-62.2488809 435.107335,55.0960328 557.361304,145.687571 Z'
          ] },
          { value: 'M364.087363,0.682469802 C643.492676,0.682469802 702.086068,60.0094098 702.086068,240.021774 C702.086068,420.034139 496.01463,551.447933 351.086068,601.943985 C206.157505,652.440037 0.0860675999,621.17021 0.0860675999,484.61282 C0.0860675999,348.05543 84.6820506,0.682469802 364.087363,0.682469802 Z' }
        ],
        easing: 'linear',
        duration: 10000,
        loop: true,
        autoplay: true
    });

  });

  // Circle
  document.querySelectorAll('.wp-block-sowmedia-animated-background.is-type-circle:not(.animation-disabled), .wp-block-sowmedia-popup-grid__section .circle').forEach((item, i) => {
    anime({
        targets: item,
        scale: [1, 1.35, 1, .85, 1],
        easing: 'linear',
        duration: 30000,
        loop: true,
        autoplay: true
    });

  });

  /*
  * Gutenberg block: FAQ
  */
  document.querySelectorAll('.schema-faq-question').forEach((element, i) => {

      element.onclick = () => {

          element.parentNode.classList.toggle('schema-faq-section--active');
  
      };

  });

  /*
  * Gutenberg block: Animated number
  */
  document.querySelectorAll('.wp-block-sowmedia-animated-number .number').forEach( counter => {
   
    inViewport( [counter], ( entry ) => {

        if ( entry.target.classList.contains('revealed') ) return;

        anime({
          targets: entry.target,
          innerText: [0, entry.target.getAttribute('data-number') ],
          easing: "linear",
          round: true,
          duration: 2000,
          update: function(a) {
            const value = a.animations[0].currentValue;
            entry.target.innerHTML = Number(value).toLocaleString('nl');
          }
        });

        entry.target.classList.add('revealed');

    });

  });

  /*
  * Gutenberg block: Popup grid
  */
  document.querySelectorAll('.wp-block-sowmedia-popup-grid').forEach( block => {

    var gridHeight = block.querySelector('.wp-block-sowmedia-popup-grid__items').offsetHeight;

    block.querySelector('.wp-block-sowmedia-popup-grid__sections').style.minHeight = gridHeight + 'px';
   
    block.querySelectorAll('.wp-block-sowmedia-popup-grid__item').forEach( item => {
   
      item.onclick = () => {

        var index = item.getAttribute('data-index');

        block.querySelectorAll('.wp-block-sowmedia-popup-grid__section').forEach( section => {

          section.style.display = 'none';

        });

        block.querySelector('.wp-block-sowmedia-popup-grid__section[data-index="'+index+'"]').style.display = 'block';

        block.querySelector('.wp-block-sowmedia-popup-grid__items').style.display = 'none';

        block.querySelector('.wp-block-sowmedia-popup-grid__sections').style.display = 'block';    

        anime({
          targets: block.querySelector('.wp-block-sowmedia-popup-grid__sections'),
          opacity: [0, 1],
          duration: 500,
          easing: 'easeOutQuint',
        });


        anime({
          targets: block.querySelector('.wp-block-sowmedia-popup-grid__section[data-index="'+index+'"]').children,
          opacity: [0, 1],
          translateY: [50, 0],
          duration: 500,
          delay: anime.stagger(100),
          easing: 'easeOutQuad'
        });

      };

    });

    block.querySelectorAll('.wp-block-sowmedia-popup-grid__section').forEach( section => {

      section.querySelector('.wp-block-button.is-style-previous button').onclick = () => {
        block.querySelector('.wp-block-sowmedia-popup-grid__items').style.display = 'grid';
        block.querySelector('.wp-block-sowmedia-popup-grid__sections').style.display = 'none';
      };

    });

    block.querySelectorAll('.wp-block-sowmedia-popup-grid__item').forEach((child, i) => {
      child.style.opacity = 0;
    });
    
    inViewport( [block], ( entry ) => {

        if ( entry.target.classList.contains('revealed-children') ) return;

        anime({
            targets: block.querySelector('.wp-block-sowmedia-popup-grid__items').children,
            opacity: [0, 1],
            translateY: [50, 0],
            duration: 250,
            delay: anime.stagger(150, {start: 500}),
            easing: 'easeOutQuad'
        });

        entry.target.classList.add('revealed-children');

    });
    
  });


  /*
  * Gutenberg block: Animted title
  */
  document.querySelectorAll('.wp-block-sowmedia-animated-title').forEach( (block, i ) => {

    inViewport( [block], ( entry ) => {

        if ( entry.target.classList.contains('revealed-children') ) return;

        var subtitles = block.querySelectorAll('li');
        var total = subtitles.length;
        var current = 0;

        setTimeout(()=>{

          subtitles[current].style.display = 'block';
          block.style.transform = 'none';
          setTimeout(()=>{
              subtitles[current].classList.add('active');
              setTimeout(()=>{
                subtitles[current].classList.remove('active');
                setTimeout(()=>{
                  subtitles[current].style.display = 'none';
                  current++;
                  current = current == total ? 0 : current;
                },500);
              },3000);
          }, 50);

          setInterval(()=>{
            subtitles[current].style.display = 'block';
            block.style.transform = 'none';
            setTimeout(()=>{
                subtitles[current].classList.add('active');
                setTimeout(()=>{
                  subtitles[current].classList.remove('active');
                  setTimeout(()=>{
                    subtitles[current].style.display = 'none';
                    current++;
                    current = current == total ? 0 : current;
                  },500);
                },3000);
            }, 50);
          }, 4000);

        },1750);

        entry.target.classList.add('revealed-children');

    });

  

  });


  /*
  * Gutenberg block: Animted logo
  */
  document.querySelectorAll('.wp-block-sowmedia-animated-logo').forEach( (block, i ) => {

    inViewport( [block], ( entry ) => {

      if ( entry.target.classList.contains('revealed-logo') ) return;

        anime({
          targets: entry.target.querySelector('#onyx'),
          opacity: [0, 1],
          translateY: [-50, 0],
          easing: 'easeOutQuad',
          duration: 750,
        });
        entry.target.querySelector('#one').style.transform = 'translateX(642px)';
        anime({
          targets: entry.target.querySelector('#one'),
          opacity: [0, 1],
          translateY: [50, 0],
          easing: 'easeOutQuad',
          duration: 750,
        });
        anime({
          targets: entry.target.querySelector('#o'),
          easing: 'easeOutQuad',
          fill: '#e4a93d',
          duration: 750,
          delay: 750
        });

      entry.target.classList.add('revealed-logo');

  });

  });

  /*
   * Gutenberg block: Columns
   */
  document.querySelectorAll('.wp-block-cb-slide').forEach((item, i) => {

    inViewport( [item], ( entry ) => {

        if ( entry.target.classList.contains('revealed-children') ) return;

        anime({
            targets: entry.target.children,
            opacity: [0, 1],
            translateY: [50, 0],
            duration: 250,
            delay: anime.stagger(150, {start: 250}),
            easing: 'easeOutQuad'
        });

        entry.target.classList.add('revealed-children');

    });

  });



  /*
    * Gutenberg block: Video hero
    */
  document.querySelectorAll('.wp-block-group.video-hero').forEach((item, i) => {

    inViewport( [item], ( entry ) => {

        if ( entry.target.classList.contains('revealed-video-hero') ) return;

        anime({
            targets: entry.target.querySelector('h1'),
            fontSize: 15,
            marginBottom: 0,
            easing: 'easeOutQuad',
            delay: 1000,
        });

        entry.target.classList.add('revealed-video-hero');

    });

  });

    /*
    * Gutenberg block: Video hero
    */
    document.querySelectorAll('.wp-block-sowmedia-visual.is-type-images-and-icon').forEach((item, i) => {


      inViewport( [item], ( entry ) => {
  
          if ( entry.target.classList.contains('revealed-visual') ) return;
  
          anime({
              targets: entry.target.querySelector('.type-main'),
              translateY: [-100, 0],
              easing: 'easeOutQuad',
              duration: 1500,
          });

          anime({
              targets: entry.target.querySelector('.type-extra'),
              translateY: [100, 0],
              easing: 'easeOutQuad',
              duration: 1500,
          }); 
  
          entry.target.classList.add('revealed-visual');
  
      });
  
    });


  
  

}

window.addEventListener('DOMContentLoaded', function (event) {
  
  contentAnimations();

    var loginLabel = document.querySelector('.menu-item.is-style-login .menu-text').innerHTML;
    tippy('.menu-item.is-style-login > a', {
        theme: 'onyx-dark',
        content: loginLabel,
        placement: 'bottom',
        animation: 'shift-toward'
    });

    anime({
      targets: this.document.querySelector('.main-header-bar-navigation'),
      opacity: [0, 1],
      easing: 'easeOutQuad',
      duration: 500,
      delay: 750,
    });
    
    document.querySelectorAll('a[href*="#goto-slide-"]').forEach( (el, i) => {

      el.onclick = () => {

        var slideClassName = el.getAttribute('href').replace('#goto-', '.');
        var slide = jQuery( slideClassName );

        if ( slide ) {

          slide.parents( '.wp-block-cb-carousel' ).slick( 'slickGoTo', slide.attr('data-slick-index') );

          // slide[0].scrollIntoView();

        }

      };

    } );

    document.querySelectorAll('.wp-block-cb-carousel').forEach( ( el, i ) => {

      el.slick.slickSetOption('adaptiveHeight', true);

   });

   jQuery('.has-stretched-link').each(function(){

    jQuery(this).parents('.wp-block-column').addClass('is-linked');

   });

   document.querySelectorAll('span[style="text-decoration: underline;"]').forEach((item, i) => {

    // Add an extra span to make animation possible
    item.innerHTML = item.innerHTML + '<span class="underline" style="width:0px;"></span>';

    // When the underline is in the viewport
    inViewport( [item], ( entry ) => {

      // Perform an animation
      anime({
        targets: entry.target.querySelector('.underline'),
        width: 'calc(100% + .5rem)',
        duration: 500,
        delay: 1250,
        easing: 'easeOutQuint'
      });

    });

  });

  jQuery('.wp-block-media-text .wp-block-cb-carousel').parents('.wp-block-media-text').addClass('has-slider');
  jQuery('.wp-block-columns .wp-block-quote.is-style-shadow').parents('.wp-block-column').addClass('has-quote');


  document.querySelectorAll('.wp-block-media-text.has-slider').forEach( (el, i) => {
    var sliderHeight = 0;
    el.querySelectorAll('.wp-block-cb-slide').forEach( (slide, j) => {
      var slideHeight = slide.offsetHeight;
      sliderHeight = ( slideHeight > sliderHeight ) ? slideHeight : sliderHeight;
    });
    el.querySelector('.wp-block-media-text__media').style.height = ( sliderHeight + 250 ) + 'px';
  });

   
    jQuery('.wp-block-cb-carousel').on('afterChange', function(slick, currentSlide){
      if ( jQuery(this).parents('.wp-block-group').find('a[href*="goto-slide-"]') ) {
        var currentSlideIndex = jQuery(this).slick('slickCurrentSlide');
        var classNames = jQuery(this).find('.wp-block-cb-slide[data-slick-index="'+currentSlideIndex+'"]').attr('class').split(' ');
        jQuery(this).parents('.wp-block-group').find('a[href*="goto-slide-"]').removeClass('active');
        classNames.forEach(className => {
          if ( className.includes('slide-') ) {
            jQuery(this).parents('.wp-block-group').find('a[href*="goto-'+className+'"]').addClass('active');
          }
        });
      }
    });

    jQuery('.slick-current').each(function() {

      var classNames = jQuery(this).attr('class').split(' ');
      classNames.forEach(className => {
        if ( className.includes('slide-') ) {
          if ( jQuery(this).parents('.wp-block-group').find('a[href*="goto-'+className+'"]') ){
            jQuery(this).parents('.wp-block-group').find('a[href*="goto-'+className+'"]').addClass('active');
          }
        }
      });
      
    });

    anime({
      targets: '.onyx-sticky-contact-button',
      easing: 'easeOutQuad',
      scale: [0, 1],
      translateY: [50, 0],
      translateX: [50, 0],
      duration: 150,
      delay: 2000
    });
    tippy('.onyx-sticky-contact-button', {
      theme: 'onyx-dark',
      content: 'Neem contact op',
      placement: 'left',
      animation: 'shift-toward'
  });

});

